import clsx from "clsx";
import { LabelPropTypes } from "./propTypes";
import "./styles.scss";

const Label = ({ text, className, isSmall = true }) => {
  return (
    <span
      className={clsx("label", {
        "label-small": isSmall,
        "label-large": !isSmall,
        [className]: className,
      })}
    >
      {text}
    </span>
  );
};

Label.propTypes = LabelPropTypes;

export default Label;
